"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _objectHash = _interopRequireDefault(require("object-hash"));

var _color = _interopRequireDefault(require("color"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _styling = require("../../toolkit/styling");

var icons = _interopRequireWildcard(require("../../toolkit/icons"));

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_BUTTON_HEIGHT = 35;

var Select = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Select, _Component);

  var _super = _createSuper(Select);

  function Select() {
    var _this;

    (0, _classCallCheck2["default"])(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;

    _this.onSelect = function (_ref) {
      var value = _ref.value;
      var onSelected = _this.props.onSelected;
      onSelected(value);
    };

    _this.renderPopoverContent = function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          _assertThisInitialize2 = _assertThisInitialize.props,
          disabled = _assertThisInitialize2.disabled,
          options = _assertThisInitialize2.options,
          soleOptionChosen = _assertThisInitialize.soleOptionChosen;

      if (disabled) {
        return null;
      }

      if (options.length == 0 || soleOptionChosen) {
        // There is only one option and it has been chosen.
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(_this.styles.optionList)
      }, options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: (0, _objectHash["default"])(option),
          onClick: function onClick() {
            return _this.onSelect(option);
          }
        }, _this.renderOption(option));
      }));
    };

    return _this;
  }

  (0, _createClass2["default"])(Select, [{
    key: "renderOption",
    value: function renderOption(option) {
      var _this$props = this.props,
          selectedValue = _this$props.selectedValue,
          dontCheckSelected = _this$props.dontCheckSelected;
      var isSelected = selectedValue == option.value;
      var opacity = isSelected ? 1 : 0.5;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.option),
        style: {
          opacity: opacity,
          padding: "13px 5px"
        }
      }, !dontCheckSelected && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.checkContainer)
      }, isSelected && /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "check",
        className: (0, _styling.css)(this.styles.check)
      })), option.img && /*#__PURE__*/_react["default"].createElement("img", {
        src: option.img,
        className: (0, _styling.css)(this.styles.icon)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.textContainer)
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.text)
      }, option.text)));
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          filterName = _this$props2.filterName,
          disabled = _this$props2.disabled,
          options = _this$props2.options,
          soleOptionChosen = this.soleOptionChosen;
      var option = this.selectedOption;

      var _ref2 = option || {},
          _ref2$text = _ref2.text,
          text = _ref2$text === void 0 ? placeholder : _ref2$text;

      var showArrow = !disabled && options.length > 0 && !soleOptionChosen;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.option),
        style: {
          padding: "6px 15px",
          flex: 1
        }
      }, filterName && /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.filterName)
      }, filterName), option && option.img && /*#__PURE__*/_react["default"].createElement("img", {
        src: option.img,
        className: (0, _styling.css)(this.styles.icon)
      }), /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.text)
      }, text), showArrow && /*#__PURE__*/_react["default"].createElement("img", {
        src: icons.chevronRight,
        className: (0, _styling.css)(this.styles.chevron)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style;
      var _this$props4 = this.props,
          renderButton = _this$props4.renderButton,
          position = _this$props4.position,
          selectedOption = this.selectedOption;
      return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        position: position,
        popoverContent: this.renderPopoverContent
      }, renderButton ? renderButton(selectedOption) : /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        className: (0, _styling.css)(this.styles.button, className)
      }, this.renderButton()));
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          primary = _this$context$theming2.primary,
          borderPrimary = _this$context$theming2.borderPrimary,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          textDark = _this$context$theming2.textDark,
          textBlack = _this$context$theming2.textBlack,
          fonts = _this$context$theming.fonts;
      var _this$props5 = this.props,
          minWidth = _this$props5.minWidth,
          iconStyle = _this$props5.iconStyle,
          buttonHeight = _this$props5.buttonHeight,
          disabled = _this$props5.disabled,
          hideBorder = _this$props5.hideBorder,
          dontCheckSelected = _this$props5.dontCheckSelected,
          _this$props5$listMaxH = _this$props5.listMaxHeight,
          listMaxHeight = _this$props5$listMaxH === void 0 ? 230 : _this$props5$listMaxH;
      var keyframes = {
        from: {
          transform: "scale(0, 0)",
          opacity: 0.5
        },
        to: {
          transform: "scale(1, 1)",
          opacity: 1
        }
      };
      var hoverBG = new _color["default"](primary).alpha(0.1).toString();
      return _aphrodite.StyleSheet.create({
        option: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          userSelect: "none",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          cursor: disabled ? "default" : "pointer",
          backgroundColor: surfaceLightest,
          color: textBlack,
          transition: "all 0.2s linear",
          ":hover": {
            opacity: !disabled ? 1 : undefined,
            backgroundColor: !disabled ? hoverBG : undefined,
            color: !disabled ? primary : undefined
          }
        },
        icon: iconStyle || {
          width: 16,
          marginRight: 7,
          objectFit: "cover"
        },
        textContainer: {
          flex: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        text: {
          flex: 1,
          lineHeight: 1.43,
          fontSize: 15,
          marginRight: 10,
          color: textDark,
          fontFamily: fonts.regular,
          marginLeft: dontCheckSelected ? 10 : 0
        },
        button: {
          border: !hideBorder ? "solid 1px ".concat(borderPrimary) : undefined,
          borderRadius: !hideBorder ? 4 : undefined,
          overflow: "hidden",
          minWidth: minWidth,
          opacity: disabled ? 0.5 : 1,
          height: buttonHeight || DEFAULT_BUTTON_HEIGHT,
          display: "flex",
          flexDirection: "row",
          backgroundColor: "white"
        },
        optionList: {
          display: "flex",
          alignItems: "stretch",
          flexDirection: "column",
          minWidth: minWidth,
          maxHeight: listMaxHeight,
          overflowY: "auto",
          padding: "10px 0px",
          fontFamily: fonts.regular
        },
        chevron: {
          transform: "rotate(90deg)",
          width: 13,
          height: 13
        },
        checkContainer: {
          width: 35,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        check: {
          // eslint-disable-next-line local-rules/no-complex-styling
          marginTop: "-3px",
          color: "#88c43f",
          animationName: [keyframes],
          animationDuration: "350ms"
        },
        filterName: {
          lineHeight: 1.43,
          fontSize: 14,
          marginRight: 10,
          marginLeft: 10,
          color: "#c1c1c1"
        }
      });
    }
  }, {
    key: "selectedOption",
    get: function get() {
      var _this$props6 = this.props,
          selectedValue = _this$props6.selectedValue,
          options = _this$props6.options;
      var selected = options.filter(function (option) {
        return option.value === selectedValue;
      });

      if (selected.length > 0) {
        return selected[0];
      }

      return null;
    }
  }, {
    key: "soleOptionChosen",
    get: function get() {
      var options = this.props.options,
          selectedOption = this.selectedOption;
      return options.length == 1 && selectedOption != null;
    }
  }]);
  return Select;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.defaultProps = {
  position: "bottom right"
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "selectedOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedOption"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "soleOptionChosen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "soleOptionChosen"), _class2.prototype)), _class2)) || _class;

var _default = Select;
exports["default"] = _default;